<script setup>
import { useRoute, useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth.js'
import BtnClosePage from '@/components/BtnClosePage.vue';
import {
    ref,
    provide,
    computed
} from 'vue';
import Navbar from '@/layouts/components/Navbar/Navbar.vue';
import Sidebar from '@/layouts/components/Sidebar/Sidebar.vue';
import { useKeyupEvent } from '@/composables/useKeyupEvent';
import ModalSeleccionVigencia from '@/components/ModalSeleccionVigencia.vue';

const expandSidebar = ref(false);
const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

provide('expandSidebar', expandSidebar);

const pageTitle = computed(() => {
    return `${route.meta.title}`
})

useKeyupEvent(event => {
    if (event.keyCode == 27) {
        if (route.meta.mainView && route.meta.mainView != "") {
            router.push({ name: route.meta.mainView })
        }
    }
})
</script>

<template>
    <!--**********************************
        Main wrapper start
    ***********************************-->
    <div id="main-wrapper">
        <Navbar  />
        <Sidebar />
        <ModalSeleccionVigencia v-if="authStore.authUser" />
        <!--**********************************
            Content body start
        ***********************************-->
        <div class="content-body highlight" :class="{ 'expand': expandSidebar }">
            <div class="card shadow-none border-0 bg-transparent pt-0">
                <div class="card-header bg-transparent py-0 border-0 px-0 sticky-top"
                    v-if="typeof pageTitle !== 'undefined' && pageTitle != 'undefined'">
                    <div class="d-flex pt-0">
                        <div class="flex-grow-1 py-auto my-auto">
                            <h4 class="py-auto my-auto text-primary ps-1">{{ pageTitle }}</h4>
                        </div>
                        <div class="px-1 py-0" v-if="route.meta.mainView">
                            <BtnClosePage :ruta="route.meta.mainView" :reloaddatatable="route.meta.reload"
                                v-if="route.meta.mainView" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body border-0 scroll-visible bg-transparent px-1 onecardlayout">
                <div class="row pt-2">
                    <div class="col-12">
                        <slot name="main">
                        </slot>
                    </div>
                </div>
            </div>
            <div class="card-footer"></div>
        </div>
        <!--**********************************
            Content body end
        ***********************************-->
    </div>
    <!--**********************************
        Main wrapper end
    ***********************************-->
</template>

<style>
#main-wrapper {
    display: flex;
}

html,
body {
    max-width: 100% !important;
    overflow-x: hidden !important;
}

/*ES EL ALTO DEL CARD DONDE SE CARGA CONTENIDO DE LAS VISTAS*/
.heightPrincipalCard {
    height: calc(100lvh - 130px) !important;
}

.content-body {
    position: relative;
    min-height: calc(100vh - 40px);
    width: 100%;
    overflow: hidden;
    transition: all 0.35s ease-in-out;
    margin-top: 40px !important;
    margin-left: 50px !important;
    padding: 10px 10px;
}

.content-body.expand {
    position: relative;
    min-height: calc(100vh - 40px);
    width: 100%;
    overflow: hidden;
    opacity: 1;
    transition: all 0.25s ease-in;
    margin-top: 40px !important;
    margin-left: 260px !important;
    padding: 10px 10px;
}

.onecardlayout {
    height: calc(100lvh - 110px) !important;
    overflow-y: auto;
    overflow-x: hidden;
}

/*ANCHO ICONOS FONT AWESOME*/
.fa-fw {
    width: 1.5em;
}


i.disabled {
    pointer-events: auto;     /* permite que se detecte el mouse */
  cursor: not-allowed;      /* muestra el puntero de "prohibido" */
  opacity: 0.5;
}
</style>
